function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import RecentlyViewedItem from './partials/recently-viewed-item';
import css from './recently-viewed-widget.scss';
import appearAnimationClasses from './appear.anim.scss';
const RecentlyViewedWidget = ({
  recentlyViewedList,
  isRecentlyViewedLoading
}) => /*#__PURE__*/React.createElement(CSSTransition, {
  in: !isRecentlyViewedLoading && !!recentlyViewedList.length,
  timeout: 500,
  classNames: appearAnimationClasses,
  unmountOnExit: true
}, /*#__PURE__*/React.createElement("div", {
  className: css.contentWrapper
}, /*#__PURE__*/React.createElement("h1", {
  className: css.title
}, "Recently Viewed"), /*#__PURE__*/React.createElement("ul", {
  className: css.listWrapper
}, recentlyViewedList.map(_ref => {
  let {
      _id
    } = _ref,
    item = _objectWithoutProperties(_ref, ["_id"]);
  return /*#__PURE__*/React.createElement("li", {
    key: _id,
    className: css.listItem
  }, /*#__PURE__*/React.createElement(RecentlyViewedItem, item));
}))));
export default RecentlyViewedWidget;